import {useTheme} from "@mui/material/styles";
import {IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import {Link} from "react-router-dom";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {QuestionMark} from "@mui/icons-material";


export const HelpMenu = ({className}) => {
  const {t} = useTranslation('general');
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t('menu.help')}>
        <IconButton
          onClick={handleClick}
          className={className}
        >
          <QuestionMark fontSize={"small"} />
        </IconButton>
      </Tooltip>

      <Menu
        id="help-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {minWidth: "250px", bgcolor: "#fefefe", borderRadius: 5, p: 1, boxShadow: 2}
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            window.open('https://worldexplore-help.freshdesk.com/support/home', '_blank');
            handleClose();
          }}
          sx={{
            borderRadius: 1,
            mx: 1,
            my: 0.5,
          }}
        >
          {t('menu.helpCenter')}
        </MenuItem>
      </Menu>
    </>
  )
}